import { render, staticRenderFns } from "./ExplicitConsentTexts.vue?vue&type=template&id=7a709b38&"
import script from "./ExplicitConsentTexts.vue?vue&type=script&lang=js&"
export * from "./ExplicitConsentTexts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports